// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'
import MapSearchController from './search/map_search_controller'
import StationAutocompleteController from './search/station_autocomplete_controller'
import TrainLineSearchController from './search/train_line_search_controller'
import BuildingsSearchController from './search/buildings_search_controller'
import CommuteSearchController from './search/commute_search_controller'
import VacancyCheckController from './search/vacancy_check_controller'
import SidemenuController from './view/sidemenu_controller'
import LightboxController from './view/lightbox_controller'
import SwiperController from './view/swiper_controller'
import ReadMoreController from './view/read_more_controller'
import FavoriteController from './view/favorite_controller'
import ModalController from './view/modal_controller'
import TabsController from './view/tabs_controller'
import ToggleController from './view/toggle_controller'
import ContactFormController from './view/contact_form_controller'
import AutoSubmitController from './auto_submit_controller'
import ModalVideoController from './view/modal_video_controller'
import HeightMatcherController from './view/height_matcher_controller'
import TooltipController from './view/tooltip_controller'
import RentSelectController from './view/rent_select_controller'
import SessionPopupController from './view/session_popup_controller'
import TranslateFormController from './view/translate_form_controller'

application.register('map-search', MapSearchController)
application.register('station-autocomplete', StationAutocompleteController)
application.register('train-line-search', TrainLineSearchController)
application.register('buildings-search', BuildingsSearchController)
application.register('commute-search', CommuteSearchController)
application.register('vacancy-check', VacancyCheckController)
application.register('sidemenu', SidemenuController)
application.register('lightbox', LightboxController)
application.register('swiper', SwiperController)
application.register('read-more', ReadMoreController)
application.register('favorite', FavoriteController)
application.register('modal', ModalController)
application.register('tabs', TabsController)
application.register('toggle', ToggleController)
application.register('contact-form', ContactFormController)
application.register('auto-submit', AutoSubmitController)
application.register('modal-video', ModalVideoController)
application.register('height-matcher', HeightMatcherController)
application.register('tooltip', TooltipController)
application.register('rent-select', RentSelectController)
application.register('session-popup', SessionPopupController)
application.register('translate-form', TranslateFormController)
